export default __webpack_public_path__ + "static/media/ksjspacecircle.58e1d45f.png";